import React from 'react';
import { Compass, Navigation } from 'lucide-react';
import { SearchRadiusKm } from '../../types/location';

interface RadiusFilterSelectorProps {
  selectedRadius: SearchRadiusKm;
  onRadiusChange: (radius: SearchRadiusKm) => void;
  className?: string;
  disabled?: boolean;
}

export const RadiusFilterSelector: React.FC<RadiusFilterSelectorProps> = ({
  selectedRadius,
  onRadiusChange,
  className = '',
  disabled = false,
}) => {
  const radiusOptions: SearchRadiusKm[] = [5, 10, 25, 50];

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <span className="text-xs font-bold text-slate-500 flex items-center gap-1">
        <Compass className="w-3.5 h-3.5 text-pink-600" />
        <span className="hidden sm:inline">Search Radius:</span>
      </span>

      <div className="flex items-center gap-1 bg-slate-100 p-1 rounded-xl border border-slate-200">
        {radiusOptions.map((radius) => {
          const isSelected = selectedRadius === radius;
          return (
            <button
              key={radius}
              type="button"
              disabled={disabled}
              onClick={() => onRadiusChange(radius)}
              className={`px-2.5 py-1 text-xs font-bold rounded-lg transition-all cursor-pointer ${
                isSelected
                  ? 'bg-pink-600 text-white shadow-xs'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-white/80'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {radius} km
            </button>
          );
        })}
      </div>
    </div>
  );
};
